var lib_core = require("lib-core");
var MasterController = require("./../master/masterController.js");
var AvatarStateMachine = require("./avatarStateMachine.js");

var AvatarController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};

lib_core.inherit(AvatarController, lib_core.Controller);
AvatarController.inject = {
    masterController : MasterController,
    userController: lib_core.UserController
};

module.exports = AvatarController;

AvatarController.prototype.createStateMachine = function () {
   return new AvatarStateMachine(this.root);
};

AvatarController.prototype.beforeLoad = function() {
    lib_core.Controller.prototype.beforeLoad.call(this);

    var self = this;
    var userModel = this.userController.getModel();

    var avatar_url = userModel.avatar();
    var profile_url = `${this.configuration.userUrl}/users/${userModel.id()}/view`;

    var masterView = this.masterController.getView();
    var tab_button = masterView.cio_ui_topnav.addAvatar(avatar_url, profile_url);

    tab_button.$el.on('Cioui:TopNavAvatar:clicked', function(e){
        var cEvent = new lib_core.GuiEvent();
        cEvent.type(lib_core.GuiEvents.AVATAR_BUTTON);
        cEvent.data("profile_url", profile_url);
        self.getStatemachine().handle(cEvent);
    });
};

AvatarController.prototype.afterLoad = function() {
    var self = this;
    var stateMachineCreator = function(){
        return self.createStateMachine();
    };
    this.masterController.getStatemachine().append(this.name(), stateMachineCreator, /.*/, null, lib_core.StateMachine.CIRCULAR, null);
};